


























































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { v4 as uuid } from "uuid";
import { DataOptions, DataTableHeader } from "vuetify";
import { ContabilitaBollettaInfo, ContabilitaError, ContabilitaPageParams, ContabilitaQueryParams, StatusContabilita, TipoOspite } from "operatn-api-client";

import { ActionTypes, AlertType } from "@/store";
import { SheetsHeaders, createTsvBlob, createXlsxBlob, downloadBlob } from "@/utils";

import TipoOspiteHandlerMixin from "@/mixins/handlers/TipoOspiteHandlerMixin";
import ContabilitaHandlerMixin from "@/mixins/handlers/ContabilitaHandlerMixin";

import OperatnDateInput from "@/components/gears/inputs/OperatnDateInput.vue";
import OperatnOspiteInput from "@/components/gears/inputs/OperatnOspiteInput.vue";


@Component({
  components: {
    OperatnDateInput,
    OperatnOspiteInput,
  },
})
export default class ContabilitaInvia extends Mixins(TipoOspiteHandlerMixin, ContabilitaHandlerMixin) {
  /* DATA */

  private formValid = false;
  private formValue = this.getEmptyBody();
  private loading = false;
  private uploading = false;
  private statusContabilita: StatusContabilita | null = null;
  private uidStatusContabilita: string | null = null;

  private tipiOspite: { id: number; label: string }[] = [];
  private loadingTipiOspite = false;

  private bollette: ContabilitaBollettaInfo[] = [];
  private selectedBollette: ContabilitaBollettaInfo[] = [];
  private totalBollette = 0;
  private success: number[] = [];
  private failed: number[] = [];
  private loadingBollette = false;
  private headers: DataTableHeader[] = [
    {
      text: "ID Persona",
      value: "ospite.id",
    },
    {
      text: "Cognome",
      value: "ospite.persona.cognome",
    },
    {
      text: "Nome",
      value: "ospite.persona.nome",
    },
    {
      text: "Codice fiscale",
      value: "ospite.persona.codiceFiscale",
    },
    {
      text: "Quietanziante",
      value: "quietanziante.quietanziante",
    },
    {
      text: "ID Bolletta",
      value: "id",
    },
    {
      text: "Causale",
      value: "siglaCausale",
    },
    {
      text: "Tipo bolletta",
      value: "tipoBolletta.tipoBolletta",
    },
    {
      text: "Canoni",
      value: "importoCanoni",
    },
    {
      text: "Consumi",
      value: "importoConsumi",
    },
    {
      text: "Totale",
      value: "importoTotale",
    },
    {
      text: "Competenza dal",
      value: "competenzaDal",
    },
    {
      text: "Competenza al",
      value: "competenzaAl",
    },
    {
      text: "Scadenza",
      value: "dataScadenza",
    },
    {
      text: "Tipo ospite",
      value: "contratto.tariffa.tipoOspite.sigla",
    },
    {
      text: "Tipo contratto",
      value: "contratto.tipoContratto.sigla",
    },
    {
      text: "Centro di costo",
      value: "centroDiCosto",
    },
    {
      text: "Fabbricato",
      value: "fabbricato",
    },
    {
      text: "Stanza",
      value: "stanza",
    },
    {
      text: "Stato",
      value: "stato",
    },
  ];
  private tableOptions: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: [],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
  };

  /* GETTERS */

  get isDisabled(): boolean {
    return !this.formValid || this.loading;
  }
  get isDisabledCarica(): boolean {
    return this.isDisabled || !this.bollette.length;
  }
  get isDisabledExport(): boolean {
    return this.isDisabled || !this.bollette.length;
  }

  get queryParams(): ContabilitaQueryParams & ContabilitaPageParams {
    return {
      startDate: this.formValue.scadenzaInizio as Date,
      endDate: this.formValue.scadenzaFine as Date,
      idTipoOspite: this.formValue.idTipoOspite ?? undefined,
      idOspite: this.formValue.idOspite ?? undefined,
      siglaCausale: this.formValue.siglaCausale ?? undefined,
      page: this.tableOptions.itemsPerPage > 0 ? this.tableOptions.page : undefined,
      pageSize: this.tableOptions.itemsPerPage > 0 ? this.tableOptions.itemsPerPage : undefined,
    };
  }

  get handledBollette() {
    return this.bollette.map((b) => this.handleBolletta(b));
  }

  get selectedBolletteIds(): number[] {
    return this.selectedBollette.map((bolletta) => bolletta.id);
  }

  get exportHeaders(): SheetsHeaders {
    const headers = this.headers.reduce((result, header) => ({ ...result, [header.value]: header.text }), {});
    delete (headers as any).stato;
    return headers;
  }

  /* METHODS */

  getEmptyBody() {
    return {
      scadenzaInizio: null as Date | null,
      scadenzaFine: null as Date | null,
      idOspite: null as number | null,
      idTipoOspite: null as number | null,
      siglaCausale: null as string | null,
    };
  }

  parseTipiOspite(tipiOspite: TipoOspite[]) {
    return tipiOspite.map((tipoOspite) => ({
      id: tipoOspite.id,
      label: `${tipoOspite.sigla} - ${tipoOspite.tipoOspite}`,
    }));
  }

  handleBolletta(bolletta: ContabilitaBollettaInfo) {
    return {
      ...bolletta,
      contratto: {
        ...bolletta.contratto,
        contrattiSuOspite: undefined,
      },
      fabbricato: bolletta.contratto.contrattiSuOspite[0].contrattiSuOspiteSuPostoLetto[0].postoLetto.stanza.fabbricato.nome,
      stanza: bolletta.contratto.contrattiSuOspite[0].contrattiSuOspiteSuPostoLetto[0].postoLetto.stanza.numeroStanza,
      stato: this.success.indexOf(bolletta.id) !== -1 ? true : this.failed.indexOf(bolletta.id) !== -1 ? false : null,
    };
  }

  async fetchBollette(): Promise<void> {
    if (!this.isDisabled) {
      try {
        this.loading = true;
        this.loadingBollette = true;
        this.totalBollette = await this.getContabilitaBolletteCount(this.queryParams);
        this.bollette = await this.getContabilitaBollette(this.queryParams);
        this.selectedBollette = [];
      } finally {
        this.loading = false;
        this.loadingBollette = false;
      }
    }
  }


  async getUploadStatus(uuid: string) {
    const res = await this.getContabilitaStatus(uuid);
    if (res) this.statusContabilita = res;
  }

  async uploadBollette(): Promise<void> {
    if (!this.isDisabledCarica) {
      this.uidStatusContabilita = uuid();
      this.statusContabilita = null;
      const interval = setInterval(() => {
        this.getUploadStatus(this.uidStatusContabilita as string);
      }, 1000);

      try {
        this.loading = true;
        this.uploading = true;
        this.success = this.selectedBollette.length
          ? await this.sendContabilitaBolletteByIds(this.selectedBolletteIds, this.uidStatusContabilita as string)
          : await this.sendContabilitaBollette(this.queryParams, this.uidStatusContabilita as string);
      } catch (error) {
        if (error instanceof ContabilitaError) {
          const nSuccessed = error.passedBollette.length;
          const nFailed = error.failedBollette.length;
          this.$store.dispatch(ActionTypes.ALERT, {
            message: `Errore nell'inviare bollette, ${nSuccessed} inviate, ${nFailed} fallite`,
            alertType: AlertType.ERROR_ALERT,
          });

          this.success.push(...error.passedBollette);
          this.failed = error.failedBollette;
        }
      } finally {
        this.uploading = false;
        this.loading = false;
      }

      clearInterval(interval);
      this.statusContabilita = null;
      this.uidStatusContabilita = null;
    }
  }

  async exportTsv(): Promise<void> {
    if (!this.isDisabledExport) {
      try {
        this.loading = true;
        const bollette = await this.getContabilitaBollette({ ...this.queryParams, page: undefined, pageSize: undefined });
        const handledBollette = bollette.map((bolletta) => this.handleBolletta(bolletta));
        const blob = createTsvBlob(this.exportHeaders, handledBollette);
        downloadBlob(blob, "contabilita_bollette.tsv");
      } catch (error) {
        this.$store.dispatch(ActionTypes.ALERT, {
          message: `Errore nell'esporatare le bollette in TSV`,
          alertType: AlertType.ERRORS_QUEUE,
        });
      } finally {
        this.loading = false;
      }
    }
  }

  async exportXlsx(): Promise<void> {
    if (!this.isDisabledExport) {
      try {
        this.loading = true;
        const bollette = await this.getContabilitaBollette({ ...this.queryParams, page: undefined, pageSize: undefined });
        const handledBollette = bollette.map((bolletta) => this.handleBolletta(bolletta));
        const blob = await createXlsxBlob("Bollette contabilità", this.exportHeaders, handledBollette);
        downloadBlob(blob, "contabilita_bollette.xlsx");
      } catch (error) {
        this.$store.dispatch(ActionTypes.ALERT, {
          message: `Errore nell'esporatare le bollette in XLSX`,
          alertType: AlertType.ERRORS_QUEUE,
        });
      } finally {
        this.loading = false;
      }
    }
  }

  async stop(): Promise<void> {
    if (this.uploading && this.uidStatusContabilita) {
      this.stopContabilitaBollette(this.uidStatusContabilita);
    }
  }

  /* WATCH */

  @Watch("formValue", { deep: true })
  watchFormValue() {
    this.bollette = [];
    this.selectedBollette = [];
  }

  @Watch("tableOptions", { deep: true })
  watchTableOptions() {
    this.fetchBollette();
  }

  /* LIFE CYCE */

  async created() {
    try {
      this.loadingTipiOspite = true;
      const tipiOspite = await this.getTipiOspite();
      this.tipiOspite = this.parseTipiOspite(tipiOspite);
    } finally {
      this.loadingTipiOspite = false;
    }
  }
}
